import React from 'react';
import PropTypes from 'prop-types';
import ReactDropzone from 'react-dropzone';
import { withTranslation } from 'react-i18next';

import { DropzoneWrapperSC, DropzoneSC } from './dropzone.styled';
import svgUploadIcon from '../../../assets/svg/upload-icon.svg';
import { decorateWithId } from '../utils';
import SvgIcon from '../../svg-icon';

class Dropzone extends React.Component {
  // handle event when user drops file into dropzone
  onDrop = (acceptedFiles, rejectedFiles) => {
    const {
      files,
      genericErrorMsg,
      onChange,
      onError,
      maxFiles,
      t
    } = this.props;

    const currentFilesLength = files.length;
    const newFilesLength = acceptedFiles.length;

    if (rejectedFiles.length > 0) {
      return onError([genericErrorMsg]);
    }

    // check if we are not exceeding max count of files
    if (currentFilesLength + newFilesLength > maxFiles) {
      const errMsg = t('dropZone.tooMutch');
      onError([errMsg]);
      return null;
    }

    const decoratedAcceptedFiles = acceptedFiles.map(item =>
      decorateWithId(item)
    );
    onError([]); // removes err stack
    onChange([...decoratedAcceptedFiles]);
  };

  innerTextHandler = isDragActive => {
    const { errors, files, maxFiles, t } = this.props;

    if (errors.length > 0) {
      return <span className="error">{errors}</span>;
    }

    if (files.length >= maxFiles) {
      return <span>{t('dropZone.noMore')}</span>;
    }
    if (isDragActive) {
      return <span>{t('dropZone.dropText')}</span>;
    }

    return <span>{t('dropZone.inactiveText')}</span>;
  };

  render() {
    const {
      description,
      minSize,
      maxSize,
      accept,
      files,
      maxFiles
    } = this.props;

    return (
      <DropzoneWrapperSC>
        {description ? (
          <div>
            <span className="description">{description}</span>
          </div>
        ) : null}
        <ReactDropzone
          onDrop={this.onDrop}
          minSize={minSize}
          maxSize={maxSize}
          accept={accept}
          noClick
        >
          {({ getRootProps, getInputProps, isDragActive }) => (
            <DropzoneSC {...getRootProps()} disabled={files.length >= maxFiles}>
              <div className="dropzone-inner-wrapper" />
              <input {...getInputProps()} />
              <SvgIcon
                icon={svgUploadIcon}
                alt="upload_icon"
                themed
                styling="primary"
                active={!(files.length >= maxFiles)}
              />
              {this.innerTextHandler(isDragActive)}
            </DropzoneSC>
          )}
        </ReactDropzone>
      </DropzoneWrapperSC>
    );
  }
}

Dropzone.propTypes = {
  files: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  errors: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  renderFiles: PropTypes.bool.isRequired,
  description: PropTypes.string,
  maxFiles: PropTypes.number,
  disabled: PropTypes.bool,
  minSize: PropTypes.number,
  maxSize: PropTypes.number,
  accept: PropTypes.string,
  genericErrorMsg: PropTypes.string,
  t: PropTypes.func.isRequired
};

Dropzone.defaultProps = {
  description: null,
  maxFiles: null,
  disabled: false,
  minSize: 0,
  maxSize: Infinity,
  accept: null,
  genericErrorMsg: null
};

export default withTranslation('components')(Dropzone);
